// Per-key React component registry for the deprecation migration wizard.
//
// If a migration key has a custom React component registered here, the
// wizard renders it; otherwise it falls back to GenericWizardForm which
// drives the wizard from the JSON schema returned by the backend.

const registry = {};

export function registerWizardComponent(key, Component, options = {}) {
  registry[key] = { Component, ...options };
}

export function getWizardForKey(key) {
  return registry[key] || null;
}

export default registry;
